import React, { ComponentPropsWithRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props extends ComponentPropsWithRef<'h3'> {}
export const H3 = (p: Props) => {
  return <h3 className={twMerge(p.className, "text-xl")}>{p.children}</h3>;
};
